import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

interface Props {
  description: string
  squared?: boolean
}

export default function EmptyList({ description, squared = false }: Props) {
  return (
    <Box className={styles.emptyList[squared ? 'squared' : 'default']}>
      {description}
    </Box>
  )
}
